import React, { CSSProperties, useContext } from "react";
import { useTranslation } from "next-i18next";
import { AppContext } from "@vahak/core/dist/app-context";
import { getRemValue } from "@vahak/core/dist/methods/getRemValue";
import useMediaQuery from "@vahak/core-ui/dist/hooks/useMediaQuery";

interface Props {
    className?: string;
    isMinimized?: boolean;
    style?: CSSProperties;
    cityName?: string;
}

const Cover = ({ className, isMinimized = false, style, cityName }: Props) => {
    const { t } = useTranslation(["transporters"]);
    const { isPhoneVerified, companyId } = useContext(AppContext);
    const mobileScreen = useMediaQuery({ queryType: "mobile" });

    return (
        <div
            className={className}
            style={{
                width: "100%",
                backgroundColor: "#08123B",
                textAlign: "center",
                color: "#FFFFFF",
                paddingTop:
                    isPhoneVerified && companyId ? (mobileScreen ? "20px" : "10px") : mobileScreen ? "55px" : "10px",
                ...style
            }}
        >
            {!isMinimized && (
                <div
                    style={{
                        height: mobileScreen ? undefined : "141px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center"
                    }}
                >
                    <h1
                        style={{
                            fontSize: mobileScreen ? getRemValue(22) : getRemValue(40),
                            lineHeight: mobileScreen ? getRemValue(22) : getRemValue(40)
                            // lineHeight: "50px"
                        }}
                    >
                        {cityName ? `India's #1 Transporters in ${cityName}` : t("transporter_cover.heading")}
                    </h1>
                    <h2
                        style={{
                            fontSize: mobileScreen ? getRemValue(18) : getRemValue(32),
                            fontFamily: "var(--font-medium)",
                            marginTop: "2px"
                        }}
                    >
                        {t("transporter_cover.sub_heading")}
                    </h2>
                </div>
            )}
        </div>
    );
};

export default Cover;
